'use strict';

export default function saCarouselContainer() {
  return {
    restrict: 'A',
    require: '^saCarousel',
    link: function ($scope, $element, $attrs, saCarousel) {
      saCarousel.setContainer($element);
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/common/carousel/carousel_container.directive.js